import { videoArchive } from '@/mocks/exposure';
import { SectionHead, Tag } from './ui';

export default function VideoSection() {
  return (
    <section id="video" className="mx-auto w-full max-w-[1280px] px-4 py-9 md:px-6 md:py-14">
      <SectionHead
        no="03"
        title="录音视频 · 多媒体材料"
        sub="带时间轴节选与声纹初检，逐句转写供对照"
        more="进入音频频道"
        href="#"
      />
      <div className="grid gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
        {videoArchive.map((v, i) => (
          <a key={i} href="#" className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <div className="relative overflow-hidden bg-foreground-900">
              <img
                src={v.img}
                alt={v.title}
                className="h-44 w-full object-cover object-top opacity-90 transition duration-500 group-hover:scale-[1.04] md:h-52"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent" />
              <span className="absolute bottom-2.5 left-2.5 inline-flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-[11px] font-medium text-background-100 backdrop-blur">
                <i className="ri-play-circle-fill text-accent-400" /> {v.duration}
              </span>
              <span className="absolute right-2.5 top-2.5">
                <Tag tone="accent">{v.tag}</Tag>
              </span>
              <span className="absolute inset-0 flex items-center justify-center opacity-0 transition group-hover:opacity-100">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                  <i className="ri-play-fill text-xl" />
                </span>
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <h3 className="font-serif text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                {v.title}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-500">{v.desc}</p>
              <span className="mt-3 flex items-center justify-between text-[11px] text-foreground-400">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" /> {v.time} 更新
                </span>
                <span className="inline-flex items-center gap-1 font-medium text-foreground-600 group-hover:text-primary-600">
                  查看材料 <i className="ri-arrow-right-line" />
                </span>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}